import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import { withRouter } from 'react-router-dom';

const styles = theme => ({
    layoutRoot: {},
});

class UserNoteList extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount = () => {
        const { getUserNoteList, auth } = this.props;

        getUserNoteList(auth.user.data.auth_id);
    }

    handleRowClick(type, user_note_detail_id) {
        // this.props.history.push(`/major/${page_type}/${major_id}`);
    }

    render() {
        const { classes, userNoteList } = this.props;

        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>User Notes</h4></div>
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                        User Notes
                    </div>
                }
                content={
                    <ReactTable
                        columns={[
                            {
                                Header: "Tab Name",
                                accessor: "ChapterName"
                            },
                            {
                                Header: "",
                                Cell: row => (
                                    <div className="flex items-center">
                                        <IconButton
                                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.handleRowClick('detail', row.original.user_note_detail_id);
                                            }}
                                        >
                                            <Icon>library_books</Icon>
                                        </IconButton>
                                        <IconButton
                                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.handleRowClick('edit', row.original.user_note_detail_id);
                                            }}
                                        >
                                            <Icon>border_color</Icon>
                                        </IconButton>
                                    </div>
                                )
                            }
                        ]}
                        data={userNoteList}
                        defaultPageSize={25}
                        className="-striped -highlight"
                        noDataText="No Majors Found"
                    />
                }
            />
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getUserNoteList: Actions.getUserNoteList,
    }, dispatch);
}

function mapStateToProps({ note, auth }) {
    return {
        auth,
        userNoteList: note.user_note.userNoteList,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(UserNoteList)));


// WEBPACK FOOTER //
// src/main/components/note/UserNoteList.js